import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Typography, Alert, IconButton, Tooltip } from '@mui/material';
import MonacoEditor from '@monaco-editor/react';

import { useColorMode } from '../../../contexts';

import { CustomEditorProps } from '.';

const JSONEditor: React.FC<CustomEditorProps> = ({ value, onChange, readonly }) => {
  const [isPreview, setIsPreview] = useState(true);
  const { mode } = useColorMode();

  const [prevReadonly, setPrevReadonly] = useState(readonly);

  if (prevReadonly !== readonly) {
    setPrevReadonly(readonly);

    if (readonly) setIsPreview(true);
  }

  let error: string | null = null;

  if (!readonly && !isPreview) {
    try {
      JSON.parse(value || '{}');
    } catch (e) {
      error = (e as Error).message;
    }
  }

  const isReadOnly = readonly || isPreview;

  return (
    <Box sx={{ maxWidth: 900, width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="subtitle2">JSON</Typography>
        {!readonly && (
          <Tooltip title={isPreview ? 'Edit' : 'Preview'}>
            <IconButton onClick={() => setIsPreview(prev => !prev)}>
              {isPreview ? <EditIcon /> : <VisibilityIcon />}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {error && !isReadOnly && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {error}
        </Alert>
      )}

      <MonacoEditor
        height="300px"
        language="json"
        value={value || ''}
        onChange={v => !isReadOnly && onChange && onChange(v || '')}
        theme={mode === 'dark' ? 'vs-dark' : 'light'}
        options={{
          readOnly: isReadOnly,
          minimap: { enabled: false },
          wordWrap: 'on',
          lineNumbers: 'on',
          fontFamily: 'Roboto Mono, monospace',
          fontSize: 16,
          scrollBeyondLastLine: false,
          automaticLayout: true
        }}
      />
    </Box>
  );
};

export default JSONEditor;
